<template lang="pug">
  .events
    .banner
    .error-wrapper(v-if="error")
      h1 活动不存在
    .tabContentWrapper
      InfoTabs(:lastUpdate="lastUpdate", :taskList="source", :hasLoaded="hasLoaded")
    footer
      .footerImg
      address Copyright &copy; 2019 JDB Just Do The Best
</template>
<script>
import InfoTabs from '../components/infoTabs'
import goback from '../components/goback'
export default {
  props: {
    source: {
      type: Array,
      default () {
        return []
      }
    },
    lastUpdate: {
      type: String,
      default () {
        return ''
      }
    },
    hasLoaded: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  components: {
    InfoTabs,
    goback
  },
  data () {
    return {
      timer: null,
      error: null,
      currentTab: ''
    }
  },
  beforeDestroy () {
    clearTimeout(this.timer)
  },
  methods: {
    changeTab (val) {
      this.currentTab = val
    }
  },
  computed: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '~breakpoint-sass/stylesheets/_breakpoint';
@import '../assets/styles/var';
@import '../assets/styles/base/base';
@import '../assets/styles/base/table';
@import '../assets/styles/base/typography';

.events {
  width: 100%;
  min-height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.banner {
  width: 100%;
  padding-top: calc(100% * 510 / 425);
  background: url('../assets/images/banner_m.png') no-repeat center top;
  background-size: contain;
  @include breakpoint(568px){
    background: url('../assets/images/banner_p.png') no-repeat center top;
    padding-top: calc(100% * 1080 / 1920);
    background-size: contain;
  }
}

.error-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba($black, 0.9);
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  font-size: 1.4em;
}

footer {
  width: 100%;
  background: $gray;
  padding-bottom: 11rem;
  @include breakpoint(orientation landscape) {
    padding-bottom: 0;
  }
  .footerImg {
    width: 100%;
    padding-top: calc(100% * 150 / 355);
    background: url('../assets/images/footer_m.jpg') no-repeat center center;
    background-size: 80% 80%;
    @include breakpoint($md_l) {
      padding-top: calc(50% * 150 / 355);
      background-size: 40% 80%;
    }
    @include breakpoint(768px) {
      padding-top: calc(50% * 150 / 355);
      background-size: 35% 70%;
    }
    @include breakpoint(1024px) {
      width: 980px;
      margin: 0 auto;
      padding-top: calc(100% * 105 / 980);
      background: url('../assets/images/footer_p.jpg') no-repeat center center;
    }
  }
  address {
    width: 100%;
    font-style: normal;
    color: $white;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px 0px;
    @include rem(font-size, 1.3rem);
    &:before {
      content: '';
      width: 100%;
      height: 3px;
      position: absolute;
      left: 0;
      top: 0;
      @include value-gradient-h($color1: $yellow-g, $color2: $pink-g);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Events.vue